import { Component, inject, Input, OnInit } from '@angular/core';

import { Store } from '@ngxs/store';

import { LoginWithRedirect } from '../../shared/state/app.actions';

@Component({
  selector: 'sh-auth-login-page',
  template: ``,
  standalone: false
})
export class LoginPageComponent implements OnInit {
  readonly #store = inject(Store);

  @Input() target: string | undefined;

  ngOnInit(): void {
    this.#store.dispatch(
      new LoginWithRedirect({
        appState: {
          target: this.target
        }
      })
    );
  }
}
